import {
  Component,
  Input,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subtitle } from "../../domain/subtitle";

@Component({
  selector: "icn-subtitles-popover",
  templateUrl: "./subtitles-popover.component.html",
  styleUrls: ["./subtitles-popover.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubtitlesComponent {
  @Input() subtitles: Subtitle[];
  @Output() close = new EventEmitter<void>();

  formatSubtitlesCount() {
    if (this.subtitles.length === 1) {
      return this.subtitles[0].language;
    }
    return this.subtitles.length;
  }

  onClose() {
    this.close.emit();
  }
}
